import React from 'react'
import { Link } from 'react-router-dom'
import { SurfaceCard } from '../../Ui'

const NotFound = ({ imageNotFound, backUrl }) => {
  return <SurfaceCard className="d-flex flex-column justify-content-center align-items-center p-5">
    <div className="d-flex flex-column justify-content-center align-items-center text-center w-100">
      <img src={imageNotFound} alt="Página No Existe" style={{
        maxHeight: '200px'
      }} />

      <h3 className="text-primary font-weight-bold mt-3">No Existe La Página</h3>
      <Link to={backUrl} className="btn btn-outline-primary mt-2">
        <i className="fa fa-arrow-left mr-2"></i>Regresar
      </Link>
    </div>
  </SurfaceCard>
}

export default NotFound
